import { types } from 'mobx-state-tree'
import { formatDate } from 'utils/date'

import { QUOTE_ICON } from '../ActivityFeedIcon'
import { ReferenceUser } from '../Actors'
import { FORTO_AVATAR, INITIALS_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { getAvatar, getTitleFromActor } from '../avatars/avatarUtils'
import { COMPANY_NAME } from '../constants'
import { IActivityMessageSection, IActivityTitle, LABELED, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

const manualQuoteTranslationMap = {
  requested: 'activity-feed_manual-quote_requested',
  declined: 'activity-feed_manual-quote_declined',
  pending: 'activity-feed_manual-quote_pending',
}

export const ManualQuoteActivity = types
  .compose(
    'ManualQuoteActivity',
    Activity,
    types.model({
      manualQuoteRequestId: types.string,
      validUntil: types.Date,
      status: types.string,
      actor: ReferenceUser,
      declineReasons: types.maybe(types.array(types.string)),
      declineCustomReason: types.maybe(types.string),
    })
  )
  .preProcessSnapshot((snapshot) => {
    const { userAuthor_id, validUntil } = snapshot
    return {
      ...snapshot,
      validUntil: new Date(validUntil),
      actor: userAuthor_id,
    }
  })
  .views((self) => ({
    get activityIcon(): string {
      return QUOTE_ICON
    },
    get avatarType(): TAvatarType {
      return self.status !== 'requested' ? FORTO_AVATAR : INITIALS_AVATAR
    },
    get avatar(): string {
      return getAvatar(self.actor)
    },
    get messageContent(): IActivityMessageSection[] {
      return [
        {
          type: TEXT,
          variant: 'body2-medium',
          content: 'activity-feed_manual-quote_manual-quote',
          translate: true,
        },
        {
          type: TEXT,
          content: ' ',
        },
        {
          type: LABELED,
          variant: 'body2-medium',
          linkText: self.manualQuoteRequestId,
          url: '/quotes',
        },
        {
          type: TEXT,
          content: ' ',
        },
        {
          type: TEXT,
          variant: 'body2-medium',
          content: manualQuoteTranslationMap[self.status],
          translate: true,
        },
        {
          type: LABELED,
          getStyle: (theme) => ({ display: 'block', margin: theme.spacing(0.5, 0, 1.2) }),
          variant: 'body2-medium',
          label: 'activity-feed_manual-quote_valid-until',
          content: formatDate(self.validUntil),
          translate: true,
          hide: self.status !== 'pending',
        },
      ]
    },
    get title(): IActivityTitle {
      return self.status !== 'requested' ? { text: COMPANY_NAME } : getTitleFromActor(self.actor)
    },
  }))

export type TManualQuoteActivity = typeof ManualQuoteActivity.Type
